import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    // Handle newsletter subscription logic here
    setEmail('');
  };

  return (
    <section className="py-20 sm:py-24 md:py-32 px-4 sm:px-8 md:px-16 bg-surface">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tighter mb-4 sm:mb-6">
          Join Jatin Interiors
        </h2>
        <p className="text-stone-600 mb-6 sm:mb-8 md:mb-12 text-base sm:text-lg">
          Receive curated design insights and exclusive collection previews.
        </p>
        
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 sm:gap-4 max-w-md sm:max-w-full mx-auto">
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 bg-surface-container-low border-none rounded-md px-4 sm:px-6 md:px-8 py-3 sm:py-4 md:py-5 focus:ring-1 focus:ring-primary/40 text-sm sm:text-base md:text-lg"
            placeholder="Your email address"
            required
          />
          <button 
            type="submit"
            className="bg-primary text-on-primary px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-5 rounded-full font-bold hover:scale-105 transition-all duration-400 text-sm sm:text-base md:text-lg"
          >
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
